<script setup lang="ts">
import { useReAuth } from '@shared/composables/useReAuth';

import KgrLoginForm from './KgrLoginForm.vue';
import KgrModal from './KgrModal.vue';
import KgrModalContent from './KgrModalContent.vue';
import KgrModalHeader from './KgrModalHeader.vue';

// 1:1 port of the Angular `kgr-layer-login` (customer-apps/user). Re-auth overlay shown by the
// router guard when a logged-out/expired session navigates to a guarded route. A successful login
// resolves the pending guard with true (navigation proceeds); closing resolves false (blocked).
const reAuth = useReAuth();

function onLoginResult(success: boolean) {
    reAuth.resolve(success);
}

function onClose() {
    reAuth.resolve(false);
}
</script>

<template>
    <KgrModal
        :open="reAuth.isOpen.value"
        width="980px"
        :close-on-backdrop-click="false"
        @close="onClose"
    >
        <KgrModalHeader
            :headline="$t('Login')"
            :close-label="$t('Schließen')"
            @close="onClose"
        />

        <KgrModalContent>
            <KgrLoginForm
                v-if="reAuth.isOpen.value"
                @login-result="onLoginResult"
            />
        </KgrModalContent>
    </KgrModal>
</template>
